import React, { useEffect, useState } from "react";
import {
  FacebookAuth,
  FunnelAdsData,
  GoogleAds,
  GoogleAuth,
  FacebookAds,
} from "./components";
import { useSelector } from "react-redux";
import { selectUserStatus } from "../../common/authenticateDashboard/authSlice";
import { Overlay } from "react-bootstrap";
import FunnelLeakageLoading from "../../components/Skeletons/FunnelLeakageLoading";
import { FunnelLeakage as FunnelLeakageImg } from "../../assets";

const FunnelLeakage = () => {
  const [optimizerStatus, setOptimizerStatus] = useState(false);
  const [loading, setLoading] = useState(true);
  const userStatus = useSelector(selectUserStatus);

  useEffect(() => {
    if (userStatus?.funnel_optimizer) {
      setOptimizerStatus(true);
    }
    setLoading(false);
  }, [userStatus]);

  if (loading) {
    return <FunnelLeakageLoading />;
  }

  return (
    <>
      {optimizerStatus ? (
        <div className="w-[75%] flex-grow p-3 bg-gray-100">
          <div className="bg-white rounded-md p-3">
            <h1 className="text-xl font-bold mb-3 text-gray-700">
              Funnel Integration
            </h1>
            {/* <FunnelAdsData /> */}
            <div className="grid grid-cols-1 md:grid-cols-2 py-4">
              <img
                src={FunnelLeakageImg}
                alt="funnel leakage"
                className="m-auto"
              />
              <div className="border-l-2 ps-4">
                <GoogleAuth />
                <FacebookAuth />
              </div>
            </div>
          </div>

          <div>
            <GoogleAds />
          </div>
          <div>
            <FacebookAds />
          </div>
        </div>
      ) : (
        <Overlay />
      )}
    </>
  );
};

export default FunnelLeakage;
